import React, { useState } from "react";
import Logo from "../assets/logo.svg";
import RiskLogo from "../assets/svg/RiskLogo.svg";
import messages from "../assets/messages.svg";
import profile from "../assets/profile.svg";
import search from "../assets/search.svg";
import {
  MdNotificationsNone,
  MdOutlineBathroom,
  MdOutlineEmojiPeople,
} from "react-icons/md";
import { FaHouseDamage } from "react-icons/fa";
import {
  BsFillPersonPlusFill,
  BsFillFileEarmarkTextFill,
} from "react-icons/bs";
import { RiLogoutBoxLine } from "react-icons/ri";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import Sidebar from "./Sidebar";
import Popup from "reactjs-popup";
import EditProfile from "./Form/Profile/EditProfile";
import OXCancel from "./OXCancel";
import InviteFriends from "./Popups/InviteFriends";
import { useAuth } from "../context/AuthContext";
import { useSelector } from "react-redux";
import PropertyForm from "./Form/Profile/PropertyForm";
import { Link } from "react-router-dom";
import AddRoomstoProperty from "./Popups/AddRoomstoProperty";
import SelectProperty from "./Popups/SelectProperty";

const NavSidebar = () => {
  const { logout } = useAuth();
  const { profile: userProfile } = useSelector((state) => state.authStore);
  const [rooms, setRooms] = useState([]);
  const [step, setStep] = useState(1);

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="relative z-[100]">
      <div className="flex justify-between items-center h-[100px] fixed w-screen px-20 bg-white">
        <img src={Logo} alt="" />
        <div className="flex gap-3 justify-between items-center">
          <div className="flex justify-center items-center relative ml-6">
            <input
              type="text"
              placeholder="search"
              className="border py-[10px] w-[150px] lg:w-[450px] xl:w-[550px] px-10 rounded-b-full rounded-r-full focus:outline-none"
            />
            <div className="flex justify-center items-center cursor-pointer">
              <img src={search} alt="" className="absolute right-[1px]" />
              <div className="absolute right-[15px]">
                <FiSearch className="text-xl text-white" />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <Popup
              trigger={
                <div className="p-[9px] border rounded-full ml-2 cursor-pointer">
                  <img
                    src={RiskLogo}
                    alt=""
                    className="cursor-pointer w-[22px] h-[22px]"
                  />
                </div>
              }
              position="bottom left"
              on={"click"}
              arrow={false}
              nested
              contentStyle={{
                padding: "10px",
                borderRadius: "12px",
                color: "#5E5BA7",
                width: "fit-content",
              }}
            >
              {(close) => (
                <div className="p-4">
                  <div className="text-primary">
                    <p className="text-center uppercase font-bold pb-5 text-sm">
                      New Item
                    </p>
                    <div className="flex justify-between">
                      <Popup
                        position="right center"
                        modal
                        trigger={
                          <div className="pr-10 flex flex-col justify-center items-center">
                            <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                              <MdOutlineBathroom className="text-xl text-primary" />
                            </div>
                            <p className="text-black text-[12px]">Rooms</p>
                          </div>
                        }
                        nested
                        lockScroll
                        contentStyle={{
                          borderRadius: "12px",
                          backgroundColor: "white",
                          width: "fit-content",
                          fontSize: "0.8rem",
                          maxHeight: "98%",
                          overflow: "auto",
                        }}
                      >
                        {(close) =>
                          step === 1 ? (
                            <SelectProperty
                              close={close}
                              rooms={rooms}
                              setRooms={setRooms}
                              setStep={setStep}
                            />
                          ) : (
                            <AddRoomstoProperty
                              close={close}
                              rooms={rooms}
                              setRooms={setRooms}
                              setStep={setStep}
                            />
                          )
                        }
                      </Popup>
                      <Popup
                        position="right center"
                        modal
                        trigger={
                          <div className="mr-10 flex flex-col justify-center items-center">
                            <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                              <FaHouseDamage className="text-xl text-primary" />
                            </div>
                            <p className="text-black text-[12px]">
                              Home/Buildings
                            </p>
                          </div>
                        }
                        nested
                        lockScroll
                        contentStyle={{
                          borderRadius: "12px",
                          backgroundColor: "white",
                          width: "fit-content",
                          fontSize: "0.8rem",
                          maxHeight: "98%",
                          overflow: "auto",
                        }}
                      >
                        <PropertyForm close={close} />
                      </Popup>
                      <Link
                        to={"/contents/addcontent"}
                        className="outline-none"
                      >
                        <div className="flex flex-col justify-center items-center">
                          <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                            <MdOutlineEmojiPeople className="text-xl text-primary" />
                          </div>
                          <p className="text-black text-[12px]">Contents</p>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="text-primary pt-5">
                    <p className="text-center uppercase font-bold pb-5 text-[12px]">
                      New Documents
                    </p>
                    <div className="flex justify-between">
                      <div className="pr-10 flex flex-col justify-center items-center">
                        <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                          <BsFillFileEarmarkTextFill className="text-xl text-primary" />
                        </div>
                        <p className="text-black text-[12px] text-center">
                          Insurance <br />
                          Documents
                        </p>
                      </div>
                      <div className="pr-10 flex flex-col justify-center items-center">
                        <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                          <BsFillFileEarmarkTextFill className="text-xl text-primary" />
                        </div>
                        <p className="text-black text-[12px] text-center">
                          Claims <br />
                          Files
                        </p>
                      </div>
                      <div className="flex flex-col justify-center items-center">
                        <div className="p-[9px] border rounded-full cursor-pointer mb-[2px]">
                          <BsFillFileEarmarkTextFill className="text-xl text-primary" />
                        </div>
                        <p className="text-black text-[12px] text-center">
                          Project <br />
                          Documents
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Popup>
            <Link to="/chats">
              <img src={messages} alt="" className="cursor-pointer ml-2" />
            </Link>

            <div className="p-[9px] border rounded-full ml-2 cursor-pointer">
              <MdNotificationsNone className="text-xl text-primary" />
            </div>
          </div>

          <div>
            <Popup
              trigger={
                <div className="flex items-center border rounded-md border-gray-200 cursor-pointer px-2 py-1">
                  <div>
                    <p className="text-xs break-normal font-bold">
                      {userProfile?.firstName} {userProfile?.lastName}
                    </p>
                    <p className="text-xs font-medium">Apartment</p>
                  </div>
                  <div className="ml-4 flex items-center cursor-pointer self-start justify-between">
                    <img
                      src={
                        userProfile?.profilePicture
                          ? userProfile.profilePicture
                          : profile
                      }
                      alt=""
                      className=" h-[3rem] w-[3rem] bg-jumbleng-primary-light object-cover rounded-full"
                    />
                  </div>

                </div>
              }
              position="bottom right"
              on={"click"}
              arrow={false}
              nested
              contentStyle={{
                padding: "10px",
                borderRadius: "12px",
                color: "#5E5BA7",
                width: "fit-content",
              }}
            >
              {(close) => (
                <div className="p-4">
                  <div className="flex items-start border-b pb-3 mb-5">
                    <div className="pr-5">
                      <p className="text-sm font-semibold text-primary">
                        {" "}
                        {userProfile?.firstName} {userProfile?.lastName}
                      </p>
                      <p className="text-sm text-black text-opacity-50">
                        {" "}
                        {userProfile?.email}
                      </p>
                    </div>
                    <Popup
                      trigger={
                        <p className="py-1 px-3 border-2 border-primary text-primary text-sm rounded-lg hover:bg-primary hover:text-white cursor-pointer font-medium">
                          Edit
                        </p>
                      }
                      position="right center"
                      modal
                      closeOnDocumentClick={false}
                      nested
                      contentStyle={{
                        borderRadius: "12px",
                        backgroundColor: "white",
                        width: "fit-content",
                        fontSize: "0.8rem",
                        maxHeight: "98%",
                        overflow: "auto",
                      }}
                    >
                      <>
                        <OXCancel close={close} />
                        <EditProfile close={close} />
                      </>
                    </Popup>
                  </div>
                  <div className="border-b mb-5">
                    <p className="font-medium text-primary pb-3">Account</p>
                    <Popup
                      trigger={
                        <div className="flex items-center pb-3 cursor-pointer">
                          <BsFillPersonPlusFill className="text-primary text-xl" />
                          <p className="font-medium pl-3 text-primary">
                            Invite
                          </p>
                        </div>
                      }
                      position="right center"
                      modal
                      lockScroll
                      closeOnDocumentClick={false}
                      nested
                      contentStyle={{
                        borderRadius: "12px",
                        backgroundColor: "white",
                        width: "fit-content",
                        fontSize: "0.8rem",
                        maxHeight: "80%",
                        overflow: "auto",
                      }}
                    >
                      <InviteFriends close={close} />
                    </Popup>

                    <div className="flex items-center pb-3 cursor-pointer">
                      <AiOutlineQuestionCircle className="text-primary text-xl" />
                      <p className="font-medium pl-3 text-primary">
                        Help & Support
                      </p>
                    </div>
                  </div>

                  <div
                    className="flex items-center text-primary cursor-pointer"
                    onClick={handleLogout}
                  >
                    <RiLogoutBoxLine className=" text-xl" />
                    <p className="font-medium pl-3 text-primary">Logout</p>
                  </div>
                </div>
              )}
            </Popup>
          </div>
        </div>
      </div>
      <Sidebar />
    </div>
  );
};

export default NavSidebar;
